import request from "@/utils/request.js";
import { LANGUAGE_PACK } from "@/api/config.js";

/**
 * 自动注册&登录
 * @param {*} params
 * @returns
 */
export const postLogin = (params) => {
  return request.post("/api/mr/v2/login", params);
};

export const postCaptcha = (params) => {
  return request.post("/api/mr/v1/email/send_captcha", params);
};

export const getUserProfile = () => {
  return request.get("/api/mr/v1/profile");
};

export const getLanguagePackage = () => {
  return request.get(
    LANGUAGE_PACK.get_all_language + `?timestamp=${new Date().getTime()}`
  );
};

export const getLanguagePackageDetail = (path) => {
  if (!path) return null;
  return request.get(path + `?timestamp=${new Date().getTime()}`);
};
